import { useState, useEffect } from 'react';

/**
 * Custom hook to detect if the current screen size is mobile
 * @param breakpoint - The breakpoint for mobile detection (default: 767px)
 * @returns boolean indicating if the screen is mobile size
 */
export const useIsMobile = (breakpoint: number = 767): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(
    typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= breakpoint);
    };

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;